import { Controller } from "@hotwired/stimulus";
import { debounce } from "../helpers/timing_helpers";

// Connects to data-controller="faceted-search"
export default class extends Controller {
  static targets = ["frame", "form"];

  connect() {
    this.perform = debounce(this.#perform.bind(this), 200);
  }

  #perform() {
    // this will wrap any inputs and convert them to a query string
    // see https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/URLSearchParams#parameters
    this.searchParams = new URLSearchParams(
      new FormData(this.formTarget),
    ).toString();

    this.frameTarget.src = `${this.formTarget.action}?${this.searchParams.toString()}`;
  }
}
